import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useRef, useState } from 'react';

import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import { TOOLTIPSTALLED } from '../../../constants';
import { SCApprovalActivityDetails } from '../scApprovalActivityDetails/SCApprovalActivityDetails';
import './ScorecardPayoutAgingActivity.scss';
import { exportExcel, statusIcon } from './scorecard-payout-aging-activity-service';
import { useGetScorecardPayoutAgingQuery } from './scorecardPayoutAgingActivitySlice';
import { ScorecardWindowComments } from '../../../components/scorecardWindowComments/ScorecardWindowComments';
import { monthNames } from '../../../utils/typeConstants';

interface ScorecardAprovalActivityProps {
    inputyear?: number;
    inputmonth?: number;
    scorecardVersion: React.Dispatch<any>;
    activeIndexForTab: React.Dispatch<any>;
    scorecardId: number | string;
    isMonthsMoreThanOne: boolean;
}

export const ScorecardPayoutAgingActivity = ({
    inputyear,
    inputmonth,
    scorecardVersion,
    activeIndexForTab,
    scorecardId,
    isMonthsMoreThanOne,
}: ScorecardAprovalActivityProps) => {
    const [scorecardApproalActivity, setScoreCardApproalActivity] = useState<any>(null);
    const menu = useRef<Menu>(null);

    const [expandedRows, setExpandedRows] = useState<any>();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [selectedScorecard, setSelectedScorecard] = useState<number>();
    const [showCommentsDialog, setShowCommentsDialog] = useState(false);
    const [selectedScorecardWindow, setSelectedScorecardWindow] = useState<number>(0);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const items = [
        {
            label: 'Notify EDS',
        },
        {
            label: 'Notify Comp',
        },
        {
            label: 'Comments',
            command: () => {
                setShowCommentsDialog(true);
            },
        }
    ];

    const { data: scorecardPayoutAging } = useGetScorecardPayoutAgingQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardId,
            isMonthsMoreThanOne,
        },
        { skip: !inputyear || !inputmonth }
    );

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };
    const closeCommentsDialog = (message: boolean) => {
        setShowCommentsDialog(!message);
    };
    useEffect(() => {
        if (scorecardPayoutAging?.data?.length > 0) {
            const data = scorecardPayoutAging.data.map((item: any) => {
                return {
                    ...item,
                    openDispute: item.open_scorecard_disputes + item.open_metric_disputes,
                };
            });
            setScoreCardApproalActivity(data);
        } else {
            setScoreCardApproalActivity([]);
        }
    }, [scorecardPayoutAging]);

    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };

    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="orders-subtable">
                <SCApprovalActivityDetails
                    inputyear={rowData.year}
                    inputmonth={rowData.month}
                    rowscorecardVersionID={rowData.scorecard_version_id}
                    scorecardName={rowData.scorecard_name}
                />
            </div>
        );
    };

    const statusIndicator = (rowData: any) => {
        const icon = statusIcon(rowData);
        return (
            <div>
                {icon ? (
                    <>
                        <img
                            className="justify-content-left"
                            src={icon}
                            alt={rowData.approvals_paused === 1 ? 'disputed' : 'resolved'}
                        />
                        <Tooltip target=".justify-content-left" position="top">
                            <div id="scapprovalactivity" className="tooltip-content">
                                <span style={{ minWidth: '1rem' }}>{TOOLTIPSTALLED}</span>
                            </div>
                        </Tooltip>
                    </>
                ) : (
                    ''
                )}
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between exportexcel">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search"
                    />
                </span>
                <Button
                    type="button"
                    icon="pi pi-arrow-up me-2"
                    className="btn-export mr-2 me-2 float-end"
                    onClick={() => {
                        exportExcel(scorecardApproalActivity);
                    }}
                    data-pr-tooltip="XLS"
                >
                    Export Summary
                </Button>
            </div>
        );
    };

    const textColorCondition = (key: number) => {
        const textColor = key < 75 ? '#E23636' : '#2AA154';
        if (key !== null) {
            return (
                <span style={{ color: textColor }}>
                    {key}
                    {key !== null && '%'}
                </span>
            );
        } else {
            return <span>--</span>;
        }
    };
    const header = renderHeader();
    const onScorecardClick = (event: any) => {
        if (event.field === 'scorecard_name') {
            const selectedScorecardVersion: any = event?.rowData?.scorecard_version_id;
            setSelectedScorecard(selectedScorecardVersion);
        }
    };
    useEffect(() => {
        if (selectedScorecard) {
            scorecardVersion(selectedScorecard);
            activeIndexForTab(1);
        } else {
            scorecardVersion(undefined);
        }
    }, [selectedScorecard]);

    const popupMenuClickHandler = (e: any, rowData: any) => {
        e.preventDefault();
        setSelectedScorecardWindow(rowData.scorecard_approval_window_id);
        menu.current?.toggle(e);
    };

    const renderActions = (rowData: any) => {
        return (
            <div
                onClick={(e: any) => popupMenuClickHandler(e, rowData)}
                aria-controls="popup_menu"
                aria-haspopup
                aria-hidden="true"
                style={{ cursor: 'pointer' }}
            >
                <i className="pi pi-ellipsis-v mt-4" style={{ fontSize: '1.2em' }} />
            </div>
        );
    };

    const approvalWindowStatusTemaplate = (row: any) => {
        if (row.approvals_paused === true)
            return <span style={{color:'red'}}>{row.approval_window_status_name + " (Stalled)"}</span>;

        return <span>{row.approval_window_status_name}</span>
    };
    const performancePeriodTemaplate = (row: any) => {
        const dateYear= monthNames[row.month ] + ' ' + row.year;
        return <span>{dateYear} </span>
    };

    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div
                className="card-header border-0"
                style={{ backgroundColor: '#e0f0ff', padding: '15px', color: '#2B3A42' }}
            >
                ScoreCard Details
            </div>
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={scorecardApproalActivity}
                    header={header}
                    rowExpansionTemplate={rowExpansionTemplate}
                    dataKey="scorecard_version_id"
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    className="scoreCardPayoutAgingActivity"
                    rows={5}
                    paginator={scorecardApproalActivity?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    onCellClick={onScorecardClick}
                    cellSelection
                    selectionMode="single"
                >
                    <Column
                        headerStyle={{ width: '1px' }}
                        bodyStyle={{ width: '1px' }}
                        body={statusIndicator}
                    />
                    <Column
                        header="Scorecard"
                        field="scorecard_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        className="linktext"
                        sortField="scorecard_name"
                    />
                    <Column
                        header="Open Agent Approval"
                        field="approval_window_status_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        body={approvalWindowStatusTemaplate}
                        sortable
                        sortField="approval_window_status_name"
                    />
                    <Column
                        header="Window Close Date"
                        field="window_close_date"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        body={(date) =>
                            date.window_close_date ? DateTemplate(date?.window_close_date) : '--'
                        }
                        sortField="window_close_date"
                    />
                    <Column
                        header="Open Disputes"
                        field="openDispute"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="openDispute"
                    />
                    <Column
                        header="Reason"
                        field="reason"
                        headerStyle={{ minWidth: '15.5rem' }}
                        bodyStyle={{ minWidth: '15.5rem' }}
                        sortable
                        sortField="reason"
                    />
                    <Column
                        header="Associate self-approved"
                        field="assoc_approve_pct"
                        body={(rowData: any) => textColorCondition(rowData.assoc_approve_pct)}
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="assoc_approve_pct"
                    />
                    <Column
                        header="TL Associates Approval"
                        field="tl_approve_pct"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        body={(rowData: any) => textColorCondition(rowData.tl_approve_pct)}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="tl_approve_pct"
                    />
                    <Column
                        header="TL Self Approval"
                        field="tl_self_approve_pct"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        body={(rowData: any) => textColorCondition(rowData.tl_self_approve_pct)}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="tl_self_approve_pct"
                    />

                    <Column
                        header="Manager Approved"
                        field="mgr_approve_pct"
                        body={(rowData: any) => textColorCondition(rowData.mgr_approve_pct)}
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="mgr_approve_pct"
                    />
                    <Column
                        header="Ready for Extract"
                        field="ready_for_extract_count"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="ready_for_extract_count"
                    />
                    <Column
                        header="Performance Period"
                        field="month"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        body={performancePeriodTemaplate}
                    />
                    <Column
                        key="expand"
                        expander={allowExpansion}
                        style={{ width: '4em', marginRight: '10px' }}
                    />
                    <Column key="actions" body={(rowData: any) => renderActions(rowData)} style={{ width: '4em' }} />
                </DataTable>
            </div>
            <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
            {showCommentsDialog &&
                <ScorecardWindowComments
                    showCommentsDialog={showCommentsDialog}
                    closeCommentsDialog={closeCommentsDialog}
                    approvalWindowId={selectedScorecardWindow}
                />
            }
        </div>
    );
};
